import { createAsyncThunk } from '@reduxjs/toolkit';
import Careers from '~api/careers';

export const getCareers = createAsyncThunk(
  'careers/getCareers',
  async (params) => {
    const response = await Careers.getCareersRequest(params);
    return response;
  },
);
